<app-auto-complete-select [itemControl]="itemControl"
                          [getItemName]="getItemName"
                          [label]="label"
                          (selected)="onSelected($event)"
                          [errors]="error ? [error] : null"
                          [search]="search">
</app-auto-complete-select>
